import Head from 'next/head';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { useRouter } from 'next/router';

function Index(props) {
  const [error, setError] = useState(null);
  const router = useRouter();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const e = urlParams.get('error');
    if (e) {
      setError(e);
    } else if (router.isReady) {
      router.push('/home');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router?.isReady]);

  return (
    <>
      <Head>
        <title>Bandicoot - App</title>
      </Head>

      {error && (
        <>
          <h4>Sorry, we can&apos;t let you in at the moment</h4>
          <p>{error}</p>
        </>
      )}
      {!error && (
        <CircularProgress />
      )}
    </>
  );
}

export default Index;
